import { springClient } from "../config/apiClient";

interface ApiKeyData {
  key: string;
}

interface ApiResponse<T> {
  data: T;
}

export const generateApiKey = async (): Promise<string> => {
  const response = await springClient.post<ApiResponse<ApiKeyData>>("/me/keys");
  return response.data.data.key;
};

export const deleteApiKey = async (key: string): Promise<void> => {
  if (!key || key.trim() === "" || key === "undefined") {
    throw new Error("유효하지 않은 API Key입니다.");
  }
  
  await springClient.delete(`/me/keys/${encodeURIComponent(key)}`);
};